import { cn } from '@Infowijs-eng/component-library/modules'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import SomtodayLogo from '../Importer/SomtodayLogo'
import MagisterLogo from '../Importer/MagisterLogo'
import getCustomerProductLAS from '../../selectors/customerProducts/getCustomerProductLAS'
import { PreferredLAS } from '../../types'

interface ExporterLASSetupProps {
  onSelectLAS?: (las: PreferredLAS) => void
  activeLAS?: PreferredLAS
}

export default function ExporterLASSetup({
  onSelectLAS = undefined,
  activeLAS = undefined,
}: ExporterLASSetupProps) {
  const { customerProductId } = useParams()
  const currentLAS = useSelector((state) => getCustomerProductLAS(state, { customerProductId }))
  const displaySomtoday = currentLAS === 'somtoday' || currentLAS === undefined
  const displayMagister = currentLAS === 'magister' || currentLAS === undefined

  return (
    <>
      <div className="font-bold">Choose exporter type</div>
      <div className="flex flex-col md:flex-row gap-3">
        {displaySomtoday && (
        <button
          disabled={currentLAS}
          aria-label="Somtoday"
          type="button"
          onClick={() => {
            onSelectLAS?.('somtoday')
          }}
          className={
            cn(
              'border-[1px] border-gray-100 rounded-lg w-full h-20 px-4 flex justify-center items-center',
              activeLAS === 'somtoday' ? 'bg-turquoise-300 disabled:bg-turquoise-100' : undefined,
            )
          }
        >
          <SomtodayLogo />
        </button>
        )}
        {displayMagister && (
        <button
          disabled={currentLAS}
          aria-label="Magister"
          type="button"
          onClick={() => {
            onSelectLAS?.('magister')
          }}
          className={
            cn(
              'border-[1px] border-gray-100 rounded-lg w-full h-20 px-4 flex justify-center items-center',
              activeLAS === 'magister' ? 'bg-turquoise-300 disabled:bg-turquoise-100' : undefined,
            )
          }
        >
          <MagisterLogo />
        </button>
        )}
      </div>
    </>
  )
}
